import * as React from 'react'
import {ReactNode} from 'react'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'

type Props = {
    children: ReactNode
}

const RecaptchaProvider = ({children}: Props) => {
    if (!process.env.GATSBY_RECAPTCHA_SITE_KEY) {
        console.error('GATSBY_RECAPTCHA_SITE_KEY is not set')
    }

    return (
        <>
            <div id="recaptcha-container" style={{display: 'none'}} />
            <GoogleReCaptchaProvider
                reCaptchaKey={process.env.GATSBY_RECAPTCHA_SITE_KEY ?? ''}
                scriptProps={{defer: true, appendTo: 'head'}}
                container={{
                    element: 'recaptcha-container',
                    parameters: {
                        badge: 'inline',
                    },
                }}
            >
                {children}
            </GoogleReCaptchaProvider>
        </>
    )
}
export default RecaptchaProvider
